import { Grid, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { ExpandMore, KeyboardArrowRight } from "@material-ui/icons";
import IconDelete from "app/common/Icon/IconDelete";
import {
  HISTORY_TAB,
  STATUS_PATIENT_ADVISE,
  STATUS_RESULT_PATIENT_ADVISE,
} from "app/common/LocalConst";
import {
  getDateTime,
  getTime,
  isRoleHisReadOnly,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import lgFullscreen from "lightgallery/plugins/fullscreen";
import lgRotate from "lightgallery/plugins/rotate";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import LightGallery from "lightgallery/react";
import { observer } from "mobx-react";
import React, { memo, useEffect, useState } from "react";

const ListAdviseItemsBlock = ({ initialPatient, setCurrentTab }) => {
  const [listGroup, setlistGroup] = useState({});
  const {
    handleClearItemPatientAdvise,
    searchAdvise,
    pageAdvise,
    handleChangeFormSearch,
    fetchImage,
    getImageUrl,
  } = useStore().patientManagementStore.listAdviseStore;
  const toggleListGroup = (index, boolean) => {
    setlistGroup((prevStatus) => ({
      ...prevStatus,
      [index]: boolean ? boolean : !prevStatus[index],
    }));
  };
  const theme = useTheme();
  const [openSubTables, setOpenSubTables] = useState({});
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isReadonly = isRoleHisReadOnly();
  const toggleSubTable = (indexParent, indexChild) => {
    const key = `${indexParent}_${indexChild}`;
    setOpenSubTables((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  return (
    <div
      style={{
        backgroundColor: "aliceblue",
        height: "100%",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Grid container spacing={1} className="m-0 w-100">
        <Grid item xs={12} className="search-title-card">
          <p className="title-block">Tư vấn gần đây</p>
          <div className="flex align-center flex-end gap-1 cursor">
            <p
              className="button-more"
              onClick={() => setCurrentTab(HISTORY_TAB)}
            >
              Xem thêm
            </p>
          </div>
        </Grid>

        <Grid item xs={12}>
          {initialPatient?.patientAdviceList?.length > 0 ? (
            <>
              {initialPatient?.patientAdviceList?.map((item, index) => {
                return (
                  <>
                    <React.Fragment key={index}>
                      <div
                        style={{
                          borderBottom: "1px solid gray",
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "5px",
                        }}
                      >
                        <div key={index}>
                          <div className="flex gap-2 items-center">
                            <span
                              onClick={() => toggleListGroup(index)}
                              className="pointer"
                            >
                              {listGroup[index] ? (
                                <ExpandMore />
                              ) : (
                                <KeyboardArrowRight />
                              )}
                            </span>

                            <span
                              style={{
                                fontSize: "var(--fs-base)",
                                fontWeight: 600,
                                color: "#3faef4",
                                borderBottom: "3px solid #3faef4",
                                paddingBottom: "2px",
                              }}
                            >
                              <div className="flex align-center gap-1">
                                <b>{getDateTime(item?.visit?.startDatetime)}</b>
                              </div>
                            </span>
                            <span style={{ fontSize: "var(--fs-base-two)" }}>
                              {STATUS_RESULT_PATIENT_ADVISE.find(
                                (el) => el?.value === item?.result
                              )?.name || ""}
                            </span>
                          </div>
                        </div>
                        <div className="flex-center gap-2">
                          {!isReadonly && (
                            <Tooltip title="Xóa tư vấn">
                              <div
                                className="flex"
                                onClick={() => {
                                  handleClearItemPatientAdvise(item);
                                }}
                              >
                                <IconDelete />
                              </div>
                            </Tooltip>
                          )}
                        </div>
                      </div>
                      {listGroup?.[index] && item?.items?.length > 0 && (
                        <table
                          border="1"
                          width="100%"
                          style={{
                            borderColor: "#ccc",
                            borderCollapse: "collapse",
                          }}
                        >
                          <thead>
                            <tr className="bg-gray-100">
                              <th></th>
                              <th className=" px-2 text-center">STT</th>
                              <th className=" px-2 text-center">
                                Người tư vấn
                              </th>
                              <th className=" px-2 text-center">Nội dung</th>
                              <th className=" px-2 text-center">Trạng thái</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.items.map((child, indexChild) => {
                              const itemStatus =
                                STATUS_PATIENT_ADVISE?.find(
                                  (it) => child?.adviceItemStatus === it?.value
                                ) || STATUS_PATIENT_ADVISE[0];

                              const readyImages = child?.attachments
                                ?.map((a) => {
                                  const url = getImageUrl(a?.id);
                                  if (!url) fetchImage(a?.id);
                                  return url
                                    ? { id: a.id, url, name: a.name }
                                    : null;
                                })
                                ?.filter(Boolean);
                              const key = `${index}_${indexChild}`;
                              const isOpen = openSubTables[key];
                              const groupedData = [
                                {
                                  label: "SP",
                                  interest:
                                    child?.customerInterestedProducts || [],
                                  confirmed:
                                    child?.customerConfirmedProducts || [],
                                  getName: (item) =>
                                    item?.drug?.name || "Không rõ tên sản phẩm",
                                },
                                {
                                  label: "DV",
                                  interest:
                                    child?.customerInterestedServices || [],
                                  confirmed:
                                    child?.customerConfirmedServices || [],
                                  getName: (item) =>
                                    item?.service?.name ||
                                    "Không rõ tên dịch vụ",
                                },
                                {
                                  label: "LT",
                                  interest:
                                    child?.customerInterestedTreatmentCards ||
                                    [],
                                  confirmed:
                                    child?.customerConfirmedTreatmentCards ||
                                    [],
                                  getName: (item) =>
                                    item?.clientCard?.name ||
                                    "Không rõ tên liệu trình",
                                },
                                {
                                  label: "Thẻ",
                                  interest:
                                    child?.customerInterestedPrepaidCards || [],
                                  confirmed:
                                    child?.customerConfirmedPrepaidCards || [],
                                  getName: (item) =>
                                    item?.clientCard?.name ||
                                    "Không rõ tên thẻ",
                                },
                              ];
                              const hasData = groupedData.some(
                                (group) =>
                                  group.interest.length > 0 ||
                                  group.confirmed.length > 0
                              );
                              return (
                                <>
                                  <tr key={indexChild}>
                                    <td></td>
                                    <td
                                      className="text-center"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        toggleSubTable(index, indexChild)
                                      }
                                    >
                                      <div className="flex items-center gap-1 pl-6">
                                        <span>{indexChild + 1}</span>
                                        {isOpen ? (
                                          <ExpandMore />
                                        ) : (
                                          <KeyboardArrowRight />
                                        )}
                                      </div>
                                    </td>
                                    <td className="text-center">
                                      <span style={{ fontWeight: "bold" }}>
                                        {child?.staff?.staffName ||
                                          child?.createdBy}
                                      </span>
                                      <br />
                                      <span style={{ fontSize: "10px" }}>
                                        {getTime(child?.modifyDate)}
                                      </span>
                                    </td>
                                    <td className="responsive-td">
                                      {child?.lastContent && (
                                        <div>{child?.lastContent}</div>
                                      )}
                                      {child?.content && (
                                        <div>{child?.content}</div>
                                      )}
                                      {child?.internalContent && (
                                        <div>
                                          <b>Ghi chú: </b>
                                          {child?.internalContent}
                                        </div>
                                      )}
                                      {child?.attachments?.length > 0 && (
                                        <LightGallery
                                          speed={500}
                                          plugins={[
                                            lgThumbnail,
                                            lgZoom,
                                            lgFullscreen,
                                            lgRotate,
                                          ]}
                                          mode="lg-fade"
                                          className="lightgallery-wrapper"
                                        >
                                          {child.attachments.map((a) => (
                                            <ImageLoader
                                              key={a.id}
                                              fileId={a.id}
                                              fetchImage={fetchImage}
                                              getImageUrl={getImageUrl}
                                              name={a.name}
                                            />
                                          ))}
                                        </LightGallery>
                                      )}
                                    </td>
                                    <td className="text-center">
                                      <Tooltip title={itemStatus?.name}>
                                        {itemStatus?.icon}
                                      </Tooltip>
                                    </td>
                                  </tr>
                                  {isOpen && (
                                    <tr>
                                      <td></td>
                                      <td colSpan={4}>
                                        <table
                                          border="1"
                                          width="100%"
                                          style={{
                                            borderColor: "#ccc",
                                            borderCollapse: "collapse",
                                          }}
                                        >
                                          <thead>
                                            <tr>
                                              <th>Quan tâm</th>
                                              <th>Đã chốt</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {hasData ? (
                                              groupedData
                                                .filter(
                                                  (group) =>
                                                    group.interest.length > 0 ||
                                                    group.confirmed.length > 0
                                                )
                                                .map((group, idx) => (
                                                  <tr key={idx}>
                                                    <td>
                                                      {group.interest.length >
                                                      0 ? (
                                                        group.interest.map(
                                                          (item, i) => (
                                                            <div
                                                              key={i}
                                                              style={{
                                                                display: "flex",
                                                                gap: "5px",
                                                              }}
                                                            >
                                                              <span
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {group.label}:
                                                              </span>
                                                              {group.getName(
                                                                item
                                                              )}
                                                            </div>
                                                          )
                                                        )
                                                      ) : (
                                                        <i>Không có</i>
                                                      )}
                                                    </td>
                                                    <td>
                                                      {group.confirmed.length >
                                                      0 ? (
                                                        group.confirmed.map(
                                                          (item, i) => (
                                                            <div
                                                              key={i}
                                                              style={{
                                                                display: "flex",
                                                                gap: "5px",
                                                              }}
                                                            >
                                                              <span
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {group.label}:
                                                              </span>
                                                              {group.getName(
                                                                item
                                                              )}
                                                            </div>
                                                          )
                                                        )
                                                      ) : (
                                                        <i>Không có</i>
                                                      )}
                                                    </td>
                                                  </tr>
                                                ))
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan={2}
                                                  className="text-center italic text-gray-500"
                                                >
                                                  Không có dữ liệu
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  )}
                                </>
                              );
                            })}
                          </tbody>
                        </table>
                      )}
                    </React.Fragment>
                  </>
                );
              })}
            </>
          ) : (
            <tr>
              <td colSpan={11} align="center">
                Chưa có dữ liệu
              </td>
            </tr>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

const ImageLoader = ({ fileId, fetchImage, getImageUrl, name }) => {
  const [imageUrl, setImageUrl] = useState(getImageUrl(fileId));

  useEffect(() => {
    if (!imageUrl) {
      fetchImage(fileId);
      const interval = setInterval(() => {
        const url = getImageUrl(fileId);
        if (url) {
          setImageUrl(url);
          clearInterval(interval);
        }
      }, 200);
      return () => clearInterval(interval);
    }
  }, [fileId, fetchImage, getImageUrl, imageUrl]);

  if (!imageUrl) {
    return (
      <div style={{ width: "100%", padding: "10px", textAlign: "center" }}>
        Đang tải ảnh...
      </div>
    );
  }

  return (
    <a
      href={imageUrl}
      style={{
        width: "calc(50% - 5px)",
        margin: "0 5px 10px 0",
        display: "inline-block",
        boxSizing: "border-box",
      }}
    >
      <img
        src={imageUrl}
        alt={name}
        style={{
          width: "100%",
          borderRadius: 4,
          objectFit: "cover",
          display: "block",
        }}
      />
    </a>
  );
};

export default memo(observer(ListAdviseItemsBlock));
